import { Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type DocumentFolder from 'stores/DocumentFolder';
import { DocumentType } from 'types/DocumentType';
import { normalizeInputSpace } from 'utils/String';

import { ModalForm, type SubmitCallback } from '../ModalForm';

export interface AddProjectModalProps {
  isVisible?: boolean;
  onClose?: () => void;
  parentDocument: DocumentFolder;
}

function AddProjectModal({
  isVisible,
  onClose,
  parentDocument,
}: AddProjectModalProps) {
  const handleFormSubmit: SubmitCallback = async (values) => {
    await parentDocument.documents.add({
      name: String(values.projectName).trimEnd(),
      type: DocumentType.PROJECT,
    });
  };

  return (
    <ModalForm
      formName="AddProjectModalForm"
      okText="Add"
      onClose={onClose}
      onSubmit={handleFormSubmit}
      open={isVisible}
      title="Add Project"
    >
      <Form.Item
        label="Project name"
        name="projectName"
        normalize={(v) => normalizeInputSpace(v)}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </ModalForm>
  );
}

export default observer(AddProjectModal);
